import {
  FormSearchSelection,
  type OptionSelectionProps,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@shared/components';

import ItemSetQuestionPropertiesTableHeader from './item-set-question-properties-table-header';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&:not(:last-of-type)': {
    borderRight: '1px solid',
    borderRightColor: theme.palette.grey[300],
  },
  borderColor: theme.palette.grey[300],
  padding: theme.spacing(2),
  fontWeight: 600,
}));

export interface ItemSetQuestionPropertiesTableProps {
  questionSize: number;
  difficultyOptions: OptionSelectionProps[];
  calculationTypeOptions: OptionSelectionProps[];
  difficultyOptionsLoading: boolean;
  calculationTypeOptionsLoading: boolean;
  prefixName?: string;
}

export default function ItemSetQuestionPropertiesTable(
  props: Readonly<ItemSetQuestionPropertiesTableProps>,
) {
  const {
    questionSize,
    prefixName = 'question',
    difficultyOptions,
    calculationTypeOptions,
    difficultyOptionsLoading,
    calculationTypeOptionsLoading,
  } = props;

  return (
    <TableContainer
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(2),
        overflow: 'hidden',
        border: '1px solid',
        borderColor: theme.palette.grey[800],
      })}
    >
      <Table
        sx={{
          border: 'none',
          borderCollapse: 'initial',
          mb: '-1px',
        }}
      >
        <ItemSetQuestionPropertiesTableHeader />
        <TableBody>
          {Array.from({ length: questionSize }).map((_, index) => {
            const prefixWithIndex = `${prefixName}.[${index}]`;

            return (
              <TableRow key={prefixWithIndex}>
                <StyledTableCell align='center'>{index + 1}</StyledTableCell>
                <StyledTableCell align='center'>
                  <FormSearchSelection
                    name={`${prefixWithIndex}.difficulty`}
                    placeholder='เลือกระดับความยาก'
                    size='small'
                    options={difficultyOptions}
                    loading={difficultyOptionsLoading}
                  />
                </StyledTableCell>
                <StyledTableCell align='center'>
                  <FormSearchSelection
                    name={`${prefixWithIndex}.calculated`}
                    placeholder='เลือกประเภทข้อสอบ'
                    size='small'
                    options={calculationTypeOptions}
                    loading={calculationTypeOptionsLoading}
                  />
                </StyledTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
